class CompanyDetailsCtrl
  @$inject: ["$rootScope", "$scope", "$q", "$stateParams", "$state", "toasty", "warning", "selector", "editor", "Company", "User"]
  constructor: ($rootScope, $scope, $q, $stateParams, $state, toasty, warning, selector, editor, Company, User)->
    promise = switch
      when $state.current.name isnt "my-account" then Company.get({_id: $stateParams._id}).$promise
      else User.profile().$promise.then (me)->
          return me.company

    promise.then (result)=>
      $scope.filter =
        company: result._id
      $scope.company = result
      options =
        _id: result._id
      Company.parents(options).$promise
    .then (parents)->
      $scope.parents = parents

    $scope.createUser = ($resource)->
      console.log 'Create'
      console.log $resource
      user = new User()
      key = "Create"
      $scope.editUser(user, key, $resource)

    $scope.editUser = (user, key = "Edit", $resource)->
      console.log 'Edit'
      console.log $resource
      user.company = $scope.company._id
      options =
        title: key + " User"
        source: user
        schema:
          name:
            first:
              type: "String"
              display: "First Name"
              required: true
            last:
              type: "String"
              display: "Last Name"
              required: true
          email:
            type: "Email"
            display: "Email"
            required: true
          password:
            type: "Password"
            display: "Password"
            required: true
      editor.edit(options).then (result)->
        if result._id
          delete result.company
        result.$save()
      .then (result)->
        toasty.success
          title: key + " User Success"
          msg: key + " User #{user.email} success"
        $resource.refresh()

    $scope.removeUser = (user, $resource)->
      options =
        title: "Remove User"
        msg: "Confirm to remove user #{user.name.first + user.name.last} ?"
      warning.warn(options).then ()->
        user.$remove()
      .then ()=>
        $resource.refresh()
        toasty.success
          title: 'Remove User Success'
          msg: "Remove User - #{user.email} success"


    #  TODO:
    $scope.showDeviceDetails = (device)->
      $state.go("devices.details", device)
    #  TODO:
    $scope.terminal = (device)->
      $state.go("devices.terminal", device)

    $scope.unassignDevice = (device, $resource)->
      options =
        title: "Unassign the Device"
        msg: "Confirm to unassign device?"
      warning.warn(options).then ()->
        device.$remove()
      .then ()=>
        $resource.refresh()
        toasty.success
          title: 'Unassign Device Success'
          msg: "Unassign Device - #{device.name} success"

    editHead = "<a><i class='fa fa-pencil-square-o'></i>Edit "
    editTail = "</a>"
    removeHead = "<a><i class='fa fa-trash'></i>Remove "
    removeTail = "</a>"

    editUser =
      html: editHead + "User" + editTail
      enabled: -> true
      click: (scope) =>
        {user} = scope
        $scope.editUser user

    removeUser =
      html: removeHead + "User" + removeTail
      enabled: -> true
      click: (scope) =>
        {user, $resource} = scope
        $scope.removeUser(user, $resource)

    deviceDetails =
      html: "<a><i class='fa fa-info'></i> Details</a>"
      enabled: -> true
      click: (scope) =>
        {device} = scope
        $scope.showDeviceDetails device

    terminal =
      html: "<a><i class='fa fa-terminal'></i> Terminal</a>"
      enabled: -> true
      click: (scope) =>
        {device} = scope
        $scope.terminal device

    unassignDevice =
      html: "<a><i class='fa fa-pencil-square-o'></i> Unassign Device</a>"
      enabled: -> true
      click: (scope) =>
        {device, $resource} = scope
        $scope.unassignDevice(device, $resource)

    $scope.menuUser = [editUser, removeUser]
    $scope.menuDevice = [deviceDetails, terminal, unassignDevice]

module.exports = CompanyDetailsCtrl



// WEBPACK FOOTER //
// ./src/component/company/details/controller.coffee